/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Typography, Button, Card, Input, Textarea } from "@material-tailwind/react";
import { RocketLaunchIcon, CloudArrowUpIcon } from "@heroicons/react/24/outline";

import Navbarsection from "../views/Home/Navbarsection";
import Footersection from "../views/Home/Footersection";
import Skeletonui from '../Components/Skeletonui';

export default function JobsPage() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bg-[#FFFBF7]">
      <Navbarsection />

      <section className="max-w-7xl mx-auto py-12 px-4 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* IMAGE SECTION */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="flex justify-center order-first lg:order-none"
          >
            <div className="relative group">
              <div className="absolute -inset-1 bg-gradient-to-r from-orange-600 to-orange-400 rounded-3xl blur opacity-25 group-hover:opacity-50 transition duration-1000"></div>
              <img
                className="relative p-4 object-contain rounded-3xl shadow-2xl bg-white w-full max-w-md lg:max-w-full"
                src="https://ik.imagekit.io/hickter/Hickter_Projects/MSWS/OTHERS/jobs.png?updatedAt=1708345830317"
                alt="Job Opportunities"
              />
            </div>
          </motion.div>

          {/* FORM SECTION */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
          >
            <Card className="p-8 md:p-12 shadow-[0_20px_50px_rgba(251,140,0,0.1)] rounded-[2.5rem] border border-orange-50 bg-white">
              <div className="mb-8">
                <Typography variant="h3" className="font-black text-gray-900 uppercase tracking-tighter">
                  Join the <span className="text-orange-600">Mission</span>
                </Typography>
                <p className="text-gray-500 font-medium mt-2">Fill out the form below to apply for current openings.</p>
              </div>

              {loading ? (
                <Skeletonui />
              ) : (
                <form className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <Typography className="text-xs font-black text-orange-900 uppercase ml-1">Full Name</Typography>
                      <Input size="lg" placeholder="Nabin Yadav" className="!border-orange-100 focus:!border-orange-600 bg-orange-50/30" labelProps={{className: "hidden"}} />
                    </div>
                    <div className="space-y-2">
                      <Typography className="text-xs font-black text-orange-900 uppercase ml-1">Email ID</Typography>
                      <Input size="lg" type="email" placeholder="nabin@example.com" className="!border-orange-100 focus:!border-orange-600 bg-orange-50/30" labelProps={{className: "hidden"}} />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <Typography className="text-xs font-black text-orange-900 uppercase ml-1">Mobile No.</Typography>
                      <Input size="lg" placeholder="+91" className="!border-orange-100 focus:!border-orange-600 bg-orange-50/30" labelProps={{className: "hidden"}} />
                    </div>
                    <div className="space-y-2">
                      <Typography className="text-xs font-black text-orange-900 uppercase ml-1">Applied For</Typography>
                      <Input size="lg" placeholder="e.g. Field Coordinator" className="!border-orange-100 focus:!border-orange-600 bg-orange-50/30" labelProps={{className: "hidden"}} />
                    </div>
                  </div>

                  <div className="space-y-2">
                    <Typography className="text-xs font-black text-orange-900 uppercase ml-1">Resume Link (Google Drive/Dropbox)</Typography>
                    <Input size="lg" placeholder="https://..." className="!border-orange-100 focus:!border-orange-600 bg-orange-50/30" labelProps={{className: "hidden"}} />
                  </div>

                  <div className="space-y-2">
                    <Typography className="text-xs font-black text-orange-900 uppercase ml-1">Experience / Bio</Typography>
                    <Textarea rows={4} placeholder="Tell us about your background..." className="!border-orange-100 focus:!border-orange-600 bg-orange-50/30" labelProps={{className: "hidden"}} />
                  </div>

                  <Button 
                    fullWidth 
                    size="lg" 
                    className="bg-orange-600 hover:bg-orange-700 rounded-2xl flex items-center justify-center gap-3 py-5 shadow-lg shadow-orange-200 transition-all active:scale-95"
                  >
                    <RocketLaunchIcon className="h-6 w-6" />
                    <span className="text-lg font-black tracking-widest">SUBMIT APPLICATION</span>
                  </Button>
                </form>
              )}
            </Card>
          </motion.div>

        </div>
      </section>

      <Footersection />
    </div>
  );
}